import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// C:\Ava_Local\Ava_API\avaai_dashboard\frontend\src\pages\education\GradeLevelsPage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
export default function GradeLevelsPage() {
    const navigate = useNavigate();
    const [selected, setSelected] = useState(null);
    const grades = [
        {
            label: "K-2",
            desc: "Early math basics like counting, simple addition, and subtraction.",
        },
        {
            label: "3-5",
            desc: "Multiplication, division, and stronger number skills.",
        },
        {
            label: "6-8",
            desc: "Advanced arithmetic, fractions, and problem solving.",
        },
        {
            label: "9-12",
            desc: "Higher level math, algebra style thinking, and complex problems.",
        },
    ];
    return (_jsx("div", { style: {
            minHeight: "100vh",
            padding: "40px 20px",
            color: "#ecfaff",
            background: "radial-gradient(circle at top, rgba(0,255,255,0.12) 0%, rgba(0,255,255,0.03) 22%, transparent 42%), linear-gradient(180deg, #03060c 0%, #06101b 48%, #02050a 100%)",
            boxSizing: "border-box",
        }, children: _jsxs("div", { style: {
                maxWidth: "1100px",
                margin: "0 auto",
            }, children: [_jsxs("div", { style: {
                        borderRadius: "26px",
                        padding: "28px",
                        marginBottom: "28px",
                        background: "rgba(7, 13, 23, 0.78)",
                        border: "1px solid rgba(0,255,255,0.18)",
                        boxShadow: "0 0 28px rgba(0,255,255,0.08), inset 0 0 24px rgba(255,255,255,0.02)",
                        backdropFilter: "blur(10px)",
                    }, children: [_jsx("div", { style: {
                                fontSize: "13px",
                                letterSpacing: "0.22em",
                                textTransform: "uppercase",
                                color: "#79f3ff",
                                fontWeight: 800,
                                marginBottom: "10px",
                            }, children: "Ava Education" }), _jsx("h1", { style: {
                                margin: 0,
                                fontSize: "clamp(34px,5vw,56px)",
                                lineHeight: 1,
                                fontWeight: 900,
                                color: "#19e6ff",
                                textShadow: "0 0 20px rgba(0,255,255,0.25)",
                            }, children: "Choose Grade Level" }), _jsx("p", { style: {
                                marginTop: "14px",
                                fontSize: "18px",
                                color: "rgba(236,250,255,0.82)",
                                maxWidth: "760px",
                            }, children: "Select a grade range so Ava adjusts explanations, difficulty, and practice problems to match the student." })] }), _jsx("div", { style: {
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                        gap: "20px",
                    }, children: grades.map((g) => {
                        const active = selected === g.label;
                        return (_jsxs("button", { onClick: () => {
                                setSelected(g.label);
                                navigate("/education/flashcards");
                            }, style: {
                                padding: "26px",
                                borderRadius: "18px",
                                border: active
                                    ? "1px solid rgba(0,255,255,0.7)"
                                    : "1px solid rgba(0,255,255,0.22)",
                                background: "linear-gradient(180deg, rgba(10,20,40,0.9) 0%, rgba(5,10,20,0.95) 100%)",
                                color: "#ecfaff",
                                cursor: "pointer",
                                textAlign: "left",
                                transition: "all .18s ease",
                                boxShadow: active
                                    ? "0 0 22px rgba(0,255,255,0.45)"
                                    : "0 10px 26px rgba(0,0,0,0.35)",
                            }, onMouseEnter: (e) => {
                                e.currentTarget.style.transform = "translateY(-4px)";
                                e.currentTarget.style.boxShadow =
                                    "0 16px 38px rgba(0,0,0,0.45), 0 0 18px rgba(0,255,255,0.35)";
                            }, onMouseLeave: (e) => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow =
                                    active
                                        ? "0 0 22px rgba(0,255,255,0.45)"
                                        : "0 10px 26px rgba(0,0,0,0.35)";
                            }, children: [_jsx("div", { style: {
                                        fontSize: "30px",
                                        fontWeight: 900,
                                        marginBottom: "10px",
                                        color: "#19e6ff",
                                    }, children: g.label }), _jsx("div", { style: {
                                        fontSize: "15px",
                                        lineHeight: 1.5,
                                        color: "rgba(236,250,255,0.75)",
                                    }, children: g.desc })] }, g.label));
                    }) }), _jsx("div", { style: {
                        marginTop: "36px",
                    }, children: _jsx("button", { onClick: () => navigate("/education"), style: {
                            padding: "12px 18px",
                            borderRadius: "10px",
                            border: "1px solid rgba(0,255,255,0.35)",
                            background: "rgba(5,12,20,0.9)",
                            color: "#ecfaff",
                            cursor: "pointer",
                        }, children: "\u2190 Back to Education" }) })] }) }));
}
